import React from 'react';

const ResultsPanel = ({ overallResults, user, taxResults }) => (
  <div className="results-panel">
    {/* Header Section */}
    <div className="results-header">
      <div className="results-header-icon">📊</div>
      <h2>Investment Returns Analysis</h2>
    </div>

    {overallResults ? (
      <div className="results-content">
        {/* XIRR Metrics Section - Clean and Simple */}
        <div className="xirr-section">
          <div className="xirr-grid">
            <div className="metric-card xirr-pre-tax">
              <div className="metric-label">XIRR (Pre-Tax Annualized)</div>
              <div className="metric-value">
                {overallResults.xirr ? (overallResults.xirr * 100).toFixed(2) + '%' : '0%'}
              </div>
            </div>

            <div className="metric-card xirr-post-tax">
              <div className="metric-label">XIRR (Post-Tax Annualized)</div>
              <div className="metric-value">
                {user && overallResults?.postTaxXirr ?
                  (overallResults.postTaxXirr * 100).toFixed(2) + '%' :
                  user ? 'Calculating...' : 'N/A'
                }
              </div>
            </div>
          </div>
        </div>

        {/* Summary Metrics Section */}
        <div className="metrics-grid">
          <div className="metric-card outflow">
            <div className="metric-icon">💰</div>
            <div className="metric-label">Total Investment (Outflows)</div>
            <div className="metric-value">
              ₹{overallResults.totalInvested ? overallResults.totalInvested.toLocaleString('en-IN') : '0'}
            </div>
          </div>

          <div className="metric-card inflow">
            <div className="metric-icon">💵</div>
            <div className="metric-label">Total Receipts (Inflows)</div>
            <div className="metric-value">
              ₹{overallResults.totalReceived ? overallResults.totalReceived.toLocaleString('en-IN') : '0'}
            </div>
          </div>

          <div className="metric-card profit-loss">
            <div className="metric-icon">
              {overallResults.netProfit && overallResults.netProfit >= 0 ? '📈' : '📉'}
            </div>
            <div className="metric-label">Net Profit/Loss (Pre-Tax)</div>
            <div className="metric-value" style={{
              color: overallResults.netProfit && overallResults.netProfit >= 0 ? '#28a745' : '#dc3545'
            }}>
              ₹{overallResults.netProfit ? Math.abs(overallResults.netProfit).toLocaleString('en-IN') : '0'}
            </div>
          </div>

          <div className="metric-card roi">
            <div className="metric-icon">🎯</div>
            <div className="metric-label">Absolute ROI (Pre-Tax)</div>
            <div className="metric-value" style={{
              color: overallResults.roi && overallResults.roi >= 0 ? '#28a745' : '#dc3545'
            }}>
              {overallResults.roi ? (overallResults.roi * 100).toFixed(2) + '%' : '0%'}
            </div>
          </div>
        </div>

        {/* Holding Period Section */}
        <div className="holding-period-section">
          <h3 className="section-title">Holding Period (Overall)</h3>
          <div className="holding-period-value">
            {overallResults.holdingPeriod ? `${overallResults.holdingPeriod} months` : '0 months'}
          </div>
        </div>

        {/* Cost & Income Summary Section */}
        <div className="summary-section">
          <h3 className="section-title">Cost & Income Summary:</h3>
          <div className="summary-grid">
            <div className="summary-item cost">
              <span className="summary-label">Total Purchase & Acquisition Costs:</span>
              <span className="summary-value">
                ₹{overallResults.totalInvested ? overallResults.totalInvested.toLocaleString('en-IN') : '0'}
              </span>
            </div>

            <div className="summary-item cost">
              <span className="summary-label">Total Other Holding Costs:</span>
              <span className="summary-value">
                ₹{overallResults.otherCosts ? overallResults.otherCosts.toLocaleString('en-IN') : '0'}
              </span>
            </div>

            <div className="summary-item cost">
              <span className="summary-label">Total Selling Costs:</span>
              <span className="summary-value">
                ₹{overallResults.sellingCosts ? overallResults.sellingCosts.toLocaleString('en-IN') : '0'}
              </span>
            </div>

            <div className="summary-item total-cost">
              <span className="summary-label">TOTAL ALL COSTS (Outflows):</span>
              <span className="summary-value">
                ₹{((overallResults.totalInvested || 0) + (overallResults.otherCosts || 0) + (overallResults.sellingCosts || 0)).toLocaleString('en-IN')}
              </span>
            </div>

            <div className="summary-item income">
              <span className="summary-label">Total Sale Proceeds:</span>
              <span className="summary-value">
                ₹{overallResults.totalReceived ? overallResults.totalReceived.toLocaleString('en-IN') : '0'}
              </span>
            </div>

            <div className="summary-item income">
              <span className="summary-label">Total Other Income (e.g. Rental):</span>
              <span className="summary-value">
                ₹{overallResults.otherIncome ? overallResults.otherIncome.toLocaleString('en-IN') : '0'}
              </span>
            </div>

            <div className="summary-item total-income">
              <span className="summary-label">TOTAL ALL RECEIPTS (Inflows):</span>
              <span className="summary-value">
                ₹{((overallResults.totalReceived || 0) + (overallResults.otherIncome || 0)).toLocaleString('en-IN')}
              </span>
            </div>
          </div>
        </div>

        {/* Cash Flows Section */}
        {/* Removed cash flows section for cleaner UI */}
      </div>
    ) : (
      <div className="results-content">
        <div className="empty-state">
          <div className="empty-state-icon">📊</div>
          <p>Add transactions to see your XIRR analysis</p>
        </div>
      </div>
    )}
  </div>
);

export default ResultsPanel;